import { useState } from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import TableTab1 from './TableTab1';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
const Tab1 = ({
  Numeric_Values,
  AttributeName,
  FromRange,
  ToRange,
  Increment,
  setselected_default_item_attribulte_data,
  selected_default_item_attribulte_data
}) => {
  return (
    <>
      <div className="row mb-3" style={{ border: '1px solid #00000059', borderRadius: '5px' }}>
        <div className="col-12">
          <p className="boxLabel m-0">Details</p>
        </div>

        <div className="col-3">
          <div className="mb-3">
            <Input
            readOnly
              id="AttributeName"
              label="Attribute Name"
              style={{ height: "30px", border: AttributeName?.Error ? '1px solid red' : '' }}
              value={AttributeName?.AttributeName || ''}
              onChange={(e) => AttributeName?.setAttributeName?.(e.target.value)}
            />
          </div>
        </div>

        <div className="col-9">
          <div className="mb-3">
            <Checkbox
              id="Numeric_Values"
              label="Numeric Values"
              value={Numeric_Values?.Numeric_Values || false}
              onChange={(val) => Numeric_Values?.setNumeric_Values?.(val)}
            />
          </div>
        </div>
      </div>
 
      {Numeric_Values?.Numeric_Values ? (
        <div className="row mb-3" style={{ border: '1px solid #00000059', borderRadius: '5px' }}>
        <div className="row">
          <div className="col-4 mt-3">
            <div className="mb-3">
              <Input
                id="FromRange"
                label="From Range"
                style={{ height: "30px", border: FromRange?.Error ? '1px solid red' : '' }}
                value={FromRange?.FromRange || ''}
                onChange={(e) => FromRange?.setFromRange?.(e.target.value)}
              />
            </div>
          </div>

          <div className="col-4 mt-3">
            <div className="mb-3">
              <Input
                id="ToRange"
                label="To Range"
                style={{ height: "30px", border: ToRange?.Error ? '1px solid red' : '' }}
                value={ToRange?.ToRange || ''}
                onChange={(e) => ToRange?.setToRange?.(e.target.value)}
              />
            </div>
          </div>

          <div className="col-4 mt-3">
            <div className="mb-3">
              <Input
                id="Increment"
                label="Increment"
                style={{ height: "30px", border: Increment?.Error ? '1px solid red' : '' }}
                value={Increment?.Increment || ''}
                onChange={(e) => Increment?.setIncrement?.(e.target.value)}
              />
            </div>
          </div>
        </div>
        </div>
      ) : (
        <div className="row mb-3" style={{ border: '1px solid #00000059', borderRadius: '5px' }}>
          <div className="col-12">
            <p className="boxLabel m-0">Item Attribute Values</p>
          </div>
          <TableTab1 setselected_default_item_attribulte_data={setselected_default_item_attribulte_data} selected_default_item_attribulte_data={selected_default_item_attribulte_data}/>
        </div>
      )}
          <div className="mt-3">
                <ActivityCard doctype="Item Attribute" docname={AttributeName?.AttributeName } />
            </div>
      
    </>
  );
};

export default Tab1;
